import axios from 'axios';
import lib from '@/lib';

export default class ChampionsModel {
	constructor() {
		this.upgradeChampionShow = false;
	}
}
